import { motion, useScroll, useTransform } from "framer-motion";

/**
 * FlowingWaves — fixed full-viewport background with multiple SVG wave layers
 * that flow horizontally on a continuous loop AND parallax vertically as the
 * page scrolls. Sits behind all content (z-index 0). Sections above must
 * use translucent or solid-light backgrounds for waves to be visible through.
 */
export default function FlowingWaves() {
  const { scrollY } = useScroll();
  const y1 = useTransform(scrollY, [0, 4000], ["0%", "-35%"]);
  const y2 = useTransform(scrollY, [0, 4000], ["0%", "-20%"]);
  const y3 = useTransform(scrollY, [0, 4000], ["0%", "-12%"]);
  const y4 = useTransform(scrollY, [0, 4000], ["0%", "-5%"]);

  return (
    <div
      aria-hidden
      className="fixed inset-0 pointer-events-none overflow-hidden"
      style={{ zIndex: 0 }}
    >
      {/* Wave 1 — deepest sky blue, flows left */}
      <motion.div style={{ y: y1 }} className="absolute -top-10 left-0 w-[220%] flow-left-slow">
        <svg viewBox="0 0 1440 200" preserveAspectRatio="none" className="w-full h-40 opacity-25">
          <path
            d="M0 100 C 240 40 480 160 720 100 C 960 40 1200 160 1440 100 L 1440 200 L 0 200 Z"
            fill="#7DD3FC"
          />
        </svg>
      </motion.div>

      {/* Wave 2 — cyan, flows right (slower than 1) */}
      <motion.div style={{ y: y2 }} className="absolute top-[35%] left-0 w-[220%] flow-right-medium">
        <svg viewBox="0 0 1440 200" preserveAspectRatio="none" className="w-full h-36 opacity-20">
          <path
            d="M0 120 C 240 60 480 180 720 120 C 960 60 1200 180 1440 120 L 1440 200 L 0 200 Z"
            fill="#22D3EE"
          />
        </svg>
      </motion.div>

      {/* Wave 3 — pale sky, flows left fast */}
      <motion.div style={{ y: y3 }} className="absolute top-[65%] left-0 w-[220%] flow-left-fast">
        <svg viewBox="0 0 1440 200" preserveAspectRatio="none" className="w-full h-32 opacity-18">
          <path
            d="M0 80 C 240 140 480 20 720 90 C 960 160 1200 30 1440 90 L 1440 200 L 0 200 Z"
            fill="#BAE6FD"
          />
        </svg>
      </motion.div>

      {/* Wave 4 — bottom, deep cyan, flows right slow */}
      <motion.div style={{ y: y4 }} className="absolute bottom-[-40px] left-0 w-[220%] flow-right-slow">
        <svg viewBox="0 0 1440 200" preserveAspectRatio="none" className="w-full h-48 opacity-22">
          <path
            d="M0 100 C 240 60 480 140 720 100 C 960 60 1200 140 1440 100 L 1440 200 L 0 200 Z"
            fill="#38BDF8"
          />
        </svg>
      </motion.div>
    </div>
  );
}
